import {
  Exam,
  FolderItem,
  Patient,
  SimpleExam,
  examCategoriesIds,
  referenceCategories,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getExamCategory, getItemId, uid } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { CompartmentCard } from "@/src/components/cards";
import { ListConstructor } from "@/src/components/fetchableLists";

import { openExamsChoiceList } from "../exams/examsChoiceList";
import { RetrievePendingExamResultsButton } from "../exams/pendingExamsButton";
import { openLabChoiceDrawer } from "../explorations/biologyIframesButton";
import { ExamCard } from "./examCard";
import { ExamGroupCard } from "./examGroupCard";
import DicomReceptionsList from "./dicomReceptionsList";

function HospitalisationExamCompartments({
  patient,
  parent,
  onSelect,
}: {
  patient: Patient;
  parent: FolderItem;
  onSelect?: (item: Exam) => void | null | undefined;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [
      "HospitalisationExamCompartments",
      searchKey,
      patient.id,
      reload,
    ],
    queryFn: () =>
      apiFetch(
        "exams",
        "loadMany",
        {
          patientId: patient.id,
          parentId: parent?.id,
        },
        "Erreur lors du chargement des examens"
      ),
  });

  // function getOrderedExams(exams: SimpleExam[]) {
  //   let allOrderedExams: SimpleExam[] = [];
  //   for (let categoryId of examCategoriesIds) {
  //     if (categoryId == "exam") continue;
  //     const categoryInfo = referenceCategories[categoryId];

  //     let exams = data?.exams?.filter((exam) => {
  //       let reference = exam?.reference;
  //       let category = getExamCategory(reference);

  //       return (
  //         category == categoryInfo.id ||
  //         (!category && categoryInfo.id == "other") ||
  //         (category == "exam" && categoryInfo.id == "other")
  //       );
  //     });
  //     allOrderedExams = [...allOrderedExams, ...(exams || [])];
  //   }
  //   return allOrderedExams;
  // }

  function getGroupedExams(exams: SimpleExam[]) {
    let groupedExams: Record<string, SimpleExam[]> = {};
    for (let exam of exams) {
      let examGroupId = getItemId(exam.examGroup);
      groupedExams[examGroupId] ||= [];
      groupedExams[examGroupId].push(exam);
    }
    return groupedExams;
  }

  let allOrderedExams = data?.exams || [];

  function getIndex(exam: SimpleExam) {
    return allOrderedExams.findIndex((orderedExam) => {
      return orderedExam.id == exam.id;
    });
  }

  return (
    <div className="c1 gap10">
      <RetrievePendingExamResultsButton
        onFound={async () => {
          setReload(reload + 1);
        }}
        patientId={patient.id!}
        parentId={getItemId(parent)}
      ></RetrievePendingExamResultsButton>
    
      <div className="grid c5 mc1 gap15">
        {examCategoriesIds.map((categoryId) => {
          if (categoryId == "exam") return null;
          const categoryInfo = referenceCategories[categoryId];

          let exams = data?.exams?.filter((exam) => {
            let reference = exam?.reference;
            let category = getExamCategory(reference);

            return (
              category == categoryInfo.id ||
              (!category && categoryInfo.id == "other") ||
              (category == "exam" && categoryInfo.id == "other")
            );
          });

          let groupedExams = getGroupedExams(exams || []);

          return (
            <CompartmentCard
              key={categoryInfo.id}
              color="orange"
              title={categoryInfo.name}
              onClick={
                onSelect == null
                  ? async () => {
                      await openExamsChoiceList({
                        categoryId,
                        parent,
                        patient,
                        onConfirm: (exams) => {
                          setReload(reload + 1);
                        },
                      });
                    }
                  : undefined
              }
              onSecondaryClick={
                categoryId == "biology"
                  ? () => openLabChoiceDrawer()
                  : undefined
              }
              secondaryButtonTitle={
                categoryId == "biology" ? "Laboratoires" : undefined
              }
            >
              {categoryId == "imaging" && (
                <DicomReceptionsList
                  patient={patient}
                  parent={parent}
                  onAssign={(dicomReception) => {
                    setReload(reload + 1);
                  }}
                />
              )}
              <ListConstructor
                data={exams}
                isLoading={isLoading}
                isError={isError}
                error={error}
              >
                <div className="grid c1 gap10">
                  {Object.entries(groupedExams).map(([examGroupId, exams]) => {
                    const examGroup = exams[0].examGroup;

                    console.log({ examGroupId, examGroup });

                    if (examGroup) {
                      return (
                        <ExamGroupCard
                          key={uid()}
                          group={examGroup}
                          exams={exams}
                          patient={patient}
                          allExams={data?.exams || []}
                          allAppointments={data?.appointments || []}
                          allServices={data?.services || []}
                          onChange={() => {
                            setReload(reload + 1);
                          }}
                        />
                      );
                    }

                    return (
                      <div key={uid()} className="c1 gap10">
                        {exams.map((exam, index) => (
                          <ExamCard
                            key={uid()}
                            exam={exam}
                            patient={patient}
                            allExams={data?.exams || []}
                            allAppointments={data?.appointments || []}
                            allServices={data?.services || []}
                            onChange={() => {
                              setReload(reload + 1);
                            }}
                          />
                        ))}
                      </div>
                    );
                  })}
                </div>
              </ListConstructor>
            </CompartmentCard>
          );
        })}
      </div>
    </div>
  );
}

export { HospitalisationExamCompartments };
